import { Injectable } from '@angular/core';
import { FortiFACBaseProvisioningService } from './base-provisioning.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AdminHealthService extends FortiFACBaseProvisioningService {

    public getHealth(): Observable<string> {
        return this.get('health/status');
    }
}
